import { render, staticRenderFns } from "./coffre.vue?vue&type=template&id=5b6847eb&"
import script from "./coffre.vue?vue&type=script&lang=ts&"
export * from "./coffre.vue?vue&type=script&lang=ts&"
import style0 from "./coffre.vue?vue&type=style&index=0&id=5b6847eb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports